import type {
  ArchivedFilter,
  GroupingFilter,
  VisibilityFilter,
} from 'features/projects/features/export/types'

export const VISIBILITY_OPTIONS: { label: string; value: VisibilityFilter }[] =
  [
    { label: 'Any', value: 'any' },
    { label: 'Internal', value: 'internal' },
    { label: 'External', value: 'external' },
  ]

export const ARCHIVED_OPTIONS: { label: string; value: ArchivedFilter }[] = [
  { label: 'Any', value: 'any' },
  { label: 'Active', value: 'active' },
  { label: 'Archived', value: 'archived' },
]

export const GROUPING_OPTIONS: { label: string; value: GroupingFilter }[] = [
  { label: 'Per dataset', value: 'dataset' },
  { label: 'Per hub', value: 'hub' },
  { label: 'Per account', value: 'account' },
  { label: 'Per account group', value: 'account_group' },
]

export const GROUPING_TOOLTIP =
  'Determines what each row of the export represents — a dataset, a hub, an account, or an account group'
